import { BreadcrumbsRoute } from "~/components/breadcrumbs/breadcrumbs.types";
import Breadcrumbs from "../breadcrumbs/breadcrumbs";
import styles from "./about-us.module.css";
import Slider from "react-slick";
import { useAboutUsInformation } from "./about-us.hook";
import { useOutletContext } from "react-router-dom";

type Props = {
  breadcrumbs: BreadcrumbsRoute[];
};

const settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  speed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
};

export const AboutUs = ({ breadcrumbs }: Props) => {
  const { isAboutUsInformationPreview, dataAboutUs, profilePic } =
  useAboutUsInformation();
  const { isMobile } = useOutletContext<any>();

  return (
    <div className={styles.aboutUsContainer}>
      <div className={styles.head}>
        <Breadcrumbs className={`${styles.back} back`} routes={breadcrumbs} />
      </div>
      <div className={styles.aboutContent}>
        {!!dataAboutUs.images.length ?
        <>
            <div className={styles.aboutSlider}>
              <Slider {...settings}>
                {dataAboutUs.images.map((image: string, index: number) =>
              <div
                key={`about-us-${index}-item`}
                className={styles.aboutUsSliderImgBox}>

                    <div className={styles.sliderImg}>
                      <img src={image} alt={image} />
                    </div>
                  </div>
              )}
              </Slider>
            </div>
            {!isMobile &&
          <div
            className={
            dataAboutUs.images.length > 1 ? styles.flexGrid : styles.full}>


                {dataAboutUs.images.map((image: string, index: number) =>
            <div
              key={`about-us-${index}-item`}
              className={styles.aboutSliderImgBoxDesktop}>

                    <div className={styles.sliderImgDesktop}>
                      <img src={image} alt={image} />
                    </div>
                  </div>
            )}
              </div>}

          </> :

        <div className={styles.imagePreview}>
            <img src={profilePic} alt={"sumer"} />
          </div>}

        {dataAboutUs.title && dataAboutUs.content &&
        <div className={styles.aboutTexts}>
            <div className={styles.aboutTextTitleBox}>
              <h1 className={styles.aboutTextTitle}>{dataAboutUs.title}</h1>
              <hr />
            </div>
            <p className={styles.aboutTextDescription}>{dataAboutUs.content}</p>
          </div>}

      </div>
      {isAboutUsInformationPreview &&
      <div className={styles.previewLayerOver} />}

    </div>);

};